import React from 'react';
import Root from './Root';
import ReactDOM from 'react-dom';
import { register as registerServiceWorker } from './serviceWorker';

if (process.env.NODE_ENV === "production")
  console.log = () => {};

ReactDOM.render(<Root />, document.getElementById('pave_inc'));
registerServiceWorker();
